import { Button } from 'antd';
import '../../style/forms/button/button.less';

export default Button;
